import { PageHeaderWrapper, Text, Title } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Box, DialogContent, Stack } from "@mui/material";
import { environmentConfig } from "@src/appV2/environment";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { PageHeaderTopRow } from "@src/appV2/redesign/components/PageHeaderTopRow";
import { TextButton } from "@src/appV2/redesign/components/TextButton";

const BADGE_IMAGE_URL = `${environmentConfig.REACT_APP_PUBLIC_ASSETS_BASE_URL}/images/badge-policy/badgeImage.png`;

export interface BadgeRequiredContentProps {
  onGetBadge: () => void;
  onOrderBadge?: () => void;
  onViewBadgePolicy?: () => void;
}

export function BadgeRequiredContent(props: BadgeRequiredContentProps) {
  const { onGetBadge, onOrderBadge, onViewBadgePolicy } = props;

  return (
    <>
      <PageHeaderWrapper variant="tertiary">
        <PageHeaderTopRow hideBackButton sx={{ minHeight: 72 }} />
      </PageHeaderWrapper>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Stack alignItems="center" textAlign="center" spacing={6}>
          <Box
            component="img"
            src={BADGE_IMAGE_URL}
            alt="Badge illustration"
            sx={{ width: 200, height: 200, objectFit: "cover" }}
          />

          <Stack spacing={3} alignItems="center">
            <Title component="h1" variant="h3">
              A badge is required at this workplace
            </Title>
            <Text variant="body1" color={(theme) => theme.palette.text.primary}>
              Order your badge or print it out as soon as possible so you have it ready to wear.
            </Text>
          </Stack>

          {isDefined(onViewBadgePolicy) && (
            <TextButton size="large" onClick={onViewBadgePolicy}>
              View badge policy
            </TextButton>
          )}
        </Stack>
      </DialogContent>

      <DialogFooter orientation="vertical">
        <Button fullWidth variant="contained" size="large" onClick={onGetBadge}>
          Continue
        </Button>
        {isDefined(onOrderBadge) && (
          <TextButton size="large" onClick={onOrderBadge}>
            Get a badge
          </TextButton>
        )}
      </DialogFooter>
    </>
  );
}
